import Vue from 'vue'
import Vuex from 'vuex'
import {getuser} from "api/login";
Vue.use(Vuex);

// 工具函数：将逗号分隔的字符串转换为数组并过滤空值
const parseCommaSeparatedString = (str) => {
  if (!str || typeof str !== 'string') return [];
  return str.split(',').filter(item => item.trim() !== '');
};
const store = new Vuex.Store({
  state () {
    return {
      user:{
        userid:'',
        username:'',
        haspower:'',
        islogin:false
      }
    }
  },
  mutations: {
      setuser(state,val){
        state.user=val;
      },
      SET_USER_TYPE(state,type){
        state.user.type=type;        
      }
  },
  actions: {
    getuserinfo ({ commit }) {
      return new Promise((resolve, reject) => {
          getuser().then(result => {            
            let uinfo={}
            const data = result.data;
            //islogin 1 登录，-1 登录无权限，2 token验证失败
            if(data.islogin==1 || data.islogin==-1) {
              uinfo = {
                userid: data.userid,
                username: data.username,
                haspower: data.hasapipower,
                islogin: data.islogin,
                ip: data.ip,
                type: data.type,
                typeList: parseCommaSeparatedString(data.typelist),
                message: data.message,
                title: ''
              }
            }else if(data.islogin==2){
              uinfo={
                userid:'',
                username:'',
                haspower:'',
                islogin:data.islogin,
                ip: '',
                type: 0,
                message: data.message,
                title: data.title
              }
            } else{
              uinfo={
                userid:'',
                username:data.username,
                haspower:'',
                islogin:data.islogin,
                ip: '',
                type: 0,
                message: '',
                title: ''
              }
            }
            commit('setuser',uinfo)
            resolve();
           }).catch(error => {
            for(let key in error){
              console.log(key,error[key])
            }
            if(error.response && error.response.data.code == 10001){
              commit('setuser',{
                userid:'',
                username:'',
                haspower:'',
                islogin:0,
                ip: '',
                type: 0,
                message: '',
                title: ''
              })
              resolve();
            }
           })
        })
    },
    setUserType({commit},type){
      commit('SET_USER_TYPE',type);
    }
  }
})


export default store;

// 导出工具函数供其他模块使用
export { parseCommaSeparatedString };
